import React, { useMemo } from 'react';
import { HomeHeader } from '../components/home/HomeHeader';
import { TodayHabitsSection } from '../components/home/TodayHabitsSection';
import { UpcomingTasksSection } from '../components/home/UpcomingTasksSection';
import { BorrowedAlertsSection } from '../components/home/BorrowedAlertsSection';
import { useAppData } from '../contexts/AppDataContext';
import { getTodayKey } from '../utils/date';
export function Home() {
  const {
    habits
  } = useAppData();
  const todayKey = getTodayKey();
  const completedToday = useMemo(() => habits.filter(h => h.completions.includes(todayKey)).length, [habits, todayKey]);
  return <div className="flex h-full flex-col" data-id="element-175" data-mp="29etwcs4unt85">
      <HomeHeader completed={completedToday} total={habits.length} data-id="element-176" data-mp="2dhgoku5fng5v" />
      <div className="flex-1 space-y-7 overflow-y-auto px-5 py-5 pb-8" data-id="element-177" data-mp="2dfm7jqxa8872">
        <TodayHabitsSection data-id="element-178" data-mp="3kuqvf96ejtj3" />
        <UpcomingTasksSection data-id="element-179" data-mp="3kxmskvafee6h" />
        <BorrowedAlertsSection data-id="element-180" data-mp="3owcdra1ph00o" />
      </div>
    </div>;
}